export enum DimensioningModeKey {
  ITEM_HIGHLIGHTING = 'itemHighlightingMode',
}
